import { createApp, App as Application, ref } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/iconfont/iconfont.css'
import '@/style/common.scss'
import 'highlight.js/styles/monokai-sublime.css'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import ElementPlus from 'element-plus'
import elementI18nZhCn from 'element-plus/es/locale/lang/zh-cn'
import elementI18nEn from 'element-plus/es/locale/lang/en'
import safeHTML from '@/common/safeHTML'
import i18n from './i18n'
import permissionsPlugin from './plugins/permissionsPlugin'
import { PermissionRouterDirective, PermissionDirective } from './common/permissionDirective'
import permissionRouterDirective from '@/common/Directive/permissionRouterDirective'
import { useElementLocal } from '@/hooks/useElementLocal'
function bindDirective(app: Application) {
  app.directive('safe-html', safeHTML)
}
const app = createApp(App)
app
  .use(store)
  .use(router)
  .use(ElementPlus)
  .directive('role', PermissionDirective)
  .use(bindDirective)
  .use(permissionsPlugin, {
    store,
  })
  .use(i18n)
  .mount('#app')
export default app
